module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _c('title', [_vm._v("The River ")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ctc",
    attrs: {
      "id": "p0009-01-0"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "pageix"
    }
  }, [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "pageix"
    }
  }), _c('p', {
    staticClass: "cct11",
    attrs: {
      "id": "p0009-P-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "pageix"
    }
  }, [_c('span', [_c('i')])]), _c('i', [_c('a', {
    attrs: {
      "href": "#/chapter3"
    }
  }, [_vm._v("A Note from the Author")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "cct11",
    attrs: {
      "id": "p0009-P-2333"
    }
  }, [_c('span', [_c('i', [_c('a', {
    attrs: {
      "href": "#/chapter4"
    }
  }, [_vm._v("From an Entry in a Journal")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0009-P-2"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/chapter5"
    }
  }, [_vm._v("Prologue")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0009-P-3"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/chapter6"
    }
  }, [_vm._v("1. The Big Hike")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0009-P-5"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Life in Kansas")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0009-P-7"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Pond")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0009-P-9"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Corn Dogs and Marbles")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0009-P-11"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Mister Earl and the Pig Trip")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0009-P-13"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The New Teacher")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0009-P-15"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. A Visitor Comes to the Farm")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0009-P-17"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. A Birthday Gift")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0010-01-0"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "pagex"
    }
  }), _c('span', {
    attrs: {
      "href": "#/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The Phone Call")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0010-P-2"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. The Trip to The River")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0010-P-4"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The Girl")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0010-P-6"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. The River Speaks")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0010-P-8"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Samuel and Big Water Adventures")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0010-P-10"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Class V")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0010-P-12"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. The Last Night")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0010-P-14"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Good-bye and The Journal")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0010-P-16"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. No More Kansas")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0010-P-18"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Hanging Out with Ezra")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0010-P-20"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. An Unexpected Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0010-P-22"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. A Dinner to Remember")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0010-P-24"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. The Night Run")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0010-P-26"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. The War Room")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0010-P-28"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. A Trip Home")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0010-P-30"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])])]), _vm._v(" "), _c('p', {
    staticClass: "cc11t",
    attrs: {
      "id": "p0010-P-32"
    }
  }, [_c('span', [_c('i', [_c('span', {
    attrs: {
      "href": "#/chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reading Group Guide")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct11",
    attrs: {
      "id": "p0010-P-34"
    }
  }, [_c('span', [_c('i', [_c('span', {
    attrs: {
      "href": "#/chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct11",
    attrs: {
      "id": "p0010-P-36"
    }
  }, [_c('span', [_c('i', [_c('span', {
    attrs: {
      "href": "#/chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author Interview")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct11",
    attrs: {
      "id": "p0010-P-38"
    }
  }, [_c('span', [_c('i', [_c('span', {
    attrs: {
      "href": "#/chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct11",
    attrs: {
      "id": "p0010-P-39"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter33b",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("An excerpt from")]), _vm._v(" Into the Canyon")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecf27548","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter2.vue
// module id = 69
// module chunks = 0